export default __webpack_public_path__ + "static/media/heroBg.37fcd317.jpg";